// antd 6 uses dayjs (not moment) for every DatePicker/RangePicker. dayjs ships a
// tiny core, so any method antd's pickers — or our own code that feeds them —
// rely on has to be registered through a plugin here, once, at app startup.
// Without this, e.g. `disabledDate={d => d.isSameOrBefore(...)}` throws
// "isSameOrBefore is not a function" the moment a panel renders.
import dayjs from 'dayjs'
import 'dayjs/locale/pt-br'
import advancedFormat from 'dayjs/plugin/advancedFormat'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
import localeData from 'dayjs/plugin/localeData'
import utc from 'dayjs/plugin/utc'
import weekOfYear from 'dayjs/plugin/weekOfYear'
import weekYear from 'dayjs/plugin/weekYear'
import weekday from 'dayjs/plugin/weekday'

// Parsing/comparison helpers our code uses directly.
dayjs.extend(customParseFormat)
dayjs.extend(isSameOrBefore)
dayjs.extend(isSameOrAfter)
dayjs.extend(utc)
// Plugins antd's picker panels rely on to render weeks and localized formats.
dayjs.extend(advancedFormat)
dayjs.extend(localeData)
dayjs.extend(weekday)
dayjs.extend(weekOfYear)
dayjs.extend(weekYear)

// Match the previous moment setup, which imported moment/locale/pt-br globally.
dayjs.locale('pt-br')

export default dayjs
